import React from 'react';
import { oneDecimal } from '../../helpers/formatters';
import styles from './region-entity-table.module.scss';
import { EntityTableHeader } from './entity-table-header';
import { InfoNotice } from './info-notice';
import { connect } from 'react-redux';
import * as selectors from '../../reducers';
import PropTypes from 'prop-types';
import {
  setActiveRegion,
  setComparedRegion,
  setActivePage,
  setActiveEntity,
} from '../../actions/ui';
import { ArrowRight } from '../../components/icons';

const EntityTableComponent = ({
  entity,
  setActiveRegion,
  setComparedRegion,
  setActivePage,
  setActiveEntity,
  isMobile,
}) => {
  const key = 'region';

  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          width: '100%',
          overflow: 'auto',
          paddingLeft: isMobile ? 20 : 0,
        }}
      >
        <table className={styles.entityRegionTable} style={{ maxWidth: 800 }}>
          <tbody>
            <EntityTableHeader entity={entity} comparing={false} />
            {entity.byRegionByEntity.map((entityRegion, i) => {
              const isClickable = !entityRegion.region.includes('Other');
              return (
                <tr className={styles.regularTableRow} key={entityRegion + i}>
                  <td
                    onClick={() => {
                      if (isClickable) {
                        setActiveEntity(null);
                        setActiveRegion(entityRegion[key]);
                        setComparedRegion(null);
                        setActivePage(key);
                      }
                    }}
                    data-clickable={isClickable}
                    style={{ maxWidth: 300 }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <div>
                        {isClickable
                          ? entityRegion[key]
                          : entityRegion[key] + ' *'}
                      </div>
                    </div>
                  </td>
                  <td className={styles.numberCell}>
                    {entityRegion.numberOfCampuses}
                  </td>
                  <td className={styles.numberCell}>
                    {oneDecimal(entityRegion.numberOfStudents).toLocaleString()}
                  </td>
                  <td className={styles.numberCell}>
                    {oneDecimal(
                      entityRegion.numberOfEmployees
                    ).toLocaleString()}
                    {entity.name.includes('Griffith') && !isClickable && ' ***'}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {isMobile && (
        <div style={{ textAlign: 'left', paddingLeft: 20, marginTop: 20 }}>
          <span className={styles.cellInfoText}>
            Scroll the table to see more
          </span>
          <ArrowRight
            fill="blue"
            width="10px"
            height="10px"
            style={{ marginLeft: 10 }}
          />
        </div>
      )}
      <div style={{ maxWidth: 800, marginLeft: 'auto', marginRight: 'auto' }}>
        <InfoNotice entityOrRegion={entity} />
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  setActiveRegion,
  setComparedRegion,
  setActivePage,
  setActiveEntity,
};

const mapStateToProps = (state, props) => ({
  isMobile: selectors.getIsMobile(state),
});

EntityTableComponent.propTypes = {
  entity: PropTypes.object,
  setActiveRegion: PropTypes.func,
  setActivePage: PropTypes.func,
  setComparedRegion: PropTypes.func,
  setActiveEntity: PropTypes.func,
};

const EntityTable = connect(
  mapStateToProps,
  mapDispatchToProps
)(EntityTableComponent);
export { EntityTable };



// WEBPACK FOOTER //
// ./src/components/region-entity-table/entity-table.js